import { type CsvColumnDefinition } from '@components';

const readByPath = (obj: Record<string, unknown>, path: string): unknown =>
  path.split('.').reduce<unknown>((value, key) => (value as Record<string, unknown>)?.[key], obj);

const toCsv = (data: Record<string, unknown>[], columns: CsvColumnDefinition[]): string => {
  const header = columns.map((column) => column.title).join(',');
  const rows = data.map((row) => columns.map((column) => readByPath(row, column.key) ?? '').join(','));

  return [header, ...rows].join('\r\n');
};

export { readByPath, toCsv };
